import type { Editor } from '@tiptap/core';
import type { Node as ProseMirrorNode } from '@tiptap/pm/model';

import type { CommentComposerValue, CommentMentionInput, CommentMentionTarget } from '@/types';

export const commentMentionKey = (mention: CommentMentionInput) =>
    mention.kind === 'resource'
        ? `${mention.kind}:${mention.resourceType}:${mention.id}`
        : `${mention.kind}:${mention.id}`;

export const serializeCommentMention = (mention: CommentMentionTarget) =>
    `@[${mention.label.replace(/\]/g, '')}](mention:${mention.key})`;

const serializeInlineNode = (node: ProseMirrorNode, mentions: Map<string, CommentMentionInput>) => {
    if (node.isText) {
        return node.text ?? '';
    }

    if (node.type.name === 'commentMention') {
        const mention = node.attrs as CommentMentionTarget;
        const input: CommentMentionInput = {
            id: mention.id,
            kind: mention.kind,
            ...(mention.kind === 'resource' && mention.resourceType
                ? { resourceType: mention.resourceType }
                : {}),
        };

        mentions.set(mention.key, input);

        return serializeCommentMention(mention);
    }

    let value = '';

    node.forEach((child) => {
        value += serializeInlineNode(child, mentions);
    });

    return value;
};

export const serializeCommentEditor = (editor: Editor): CommentComposerValue => {
    const mentions = new Map<string, CommentMentionInput>();
    const blocks: string[] = [];

    editor.state.doc.forEach((block) => {
        blocks.push(serializeInlineNode(block, mentions));
    });

    return {
        mentions: [...mentions.values()],
        message: blocks.join('\n').trim(),
    };
};
